import { CreateScientificAreaType } from "../../../types/ScientificAreas";
import { post } from "../../../utils/axios-config";
import { SCIENTIFICAREAS } from "../../../utils/constants";

export const createScientificArea = async (data: CreateScientificAreaType) => await post<CreateScientificAreaType, string>(SCIENTIFICAREAS, data);